import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

// 根据域名自动选择环境配置
const getHasuraEndpoint = () => {
  // 优先使用环境变量
  if (process.env.HASURA_GRAPHQL_URL) {
    return process.env.HASURA_GRAPHQL_URL;
  }

  // 根据域名自动选择
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // 本地开发 → 使用测试环境
    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.endsWith('.local')
    ) {
      return 'https://test-api.sector0x.com/v1/graphql';
    }

    // 生产环境域名
    if (hostname === 'dashboard.sector0x.com') {
      return 'https://api.sector0x.com/v1/graphql';
    }

    // 测试环境域名
    if (hostname === 'test-dashboard.sector0x.com') {
      return 'https://test-api.sector0x.com/v1/graphql';
    }
  }

  // 默认生产环境
  return 'https://api.sector0x.com/v1/graphql';
};

const HASURA_GRAPHQL_ENDPOINT = getHasuraEndpoint();
const httpLink = createHttpLink({
  uri: HASURA_GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
  // 每次请求动态读取最新的 token（由 LogtoWrapper 周期刷新）
  const accessToken = localStorage.getItem('logto_access_token');
  const nextHeaders: Record<string, string> = { ...(headers || {}) } as Record<string, string>;
  if (accessToken) nextHeaders.Authorization = `Bearer ${accessToken}`;
  return { headers: nextHeaders };
});

const errorLink = onError((error) => {
  const net: any = (error as any)?.networkError;
  const status = net?.statusCode ?? net?.status;

  if (status === 401) {
    try { localStorage.removeItem('logto_access_token'); } catch {}
    const url = new URL('/user/login', window.location.origin);
    url.searchParams.set('force', '1');
    window.location.replace(url.toString());
  }
});

export const apolloClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
    query: {
      fetchPolicy: 'cache-first',
    },
  },
});
